export type CameraView = {
  position: readonly [number, number, number];
  target: readonly [number, number, number];
};

export type OrientationCameraViews = Record<"head" | "torso", CameraView>;

export const DEFAULT_CAMERA_VIEW: CameraView = {
  position: [0, 0.05, 2.1],
  target: [0, 0, 0],
};

export function createDefaultCameraViews(): OrientationCameraViews {
  return {
    head: { position: [...DEFAULT_CAMERA_VIEW.position], target: [...DEFAULT_CAMERA_VIEW.target] },
    torso: { position: [...DEFAULT_CAMERA_VIEW.position], target: [...DEFAULT_CAMERA_VIEW.target] },
  };
}

export function updateCameraViews(
  views: OrientationCameraViews,
  source: "head" | "torso",
  cameraView: CameraView,
  linked: boolean,
): OrientationCameraViews {
  if (linked) return { head: cameraView, torso: cameraView };
  return { ...views, [source]: cameraView };
}

export function linkCameraViews(
  views: OrientationCameraViews,
  source: "head" | "torso",
): OrientationCameraViews {
  return { head: views[source], torso: views[source] };
}
